import { render, staticRenderFns } from "./EventChart.vue?vue&type=template&id=a8a73520&scoped=true"
import script from "./EventChart.vue?vue&type=script&lang=ts"
export * from "./EventChart.vue?vue&type=script&lang=ts"
import style0 from "./EventChart.vue?vue&type=style&index=0&id=a8a73520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a73520",
  null
  
)

export default component.exports